import styled from 'styled-components';

import { Button } from '@thinknet-gmbh/platform-common-ui';

export const WarningWrapper = styled.div`
  display: flex;
  background-color: ${({ theme }) => theme.colors.tone.lightYellow};
  border-radius: 8px;
  padding: 11px 18px;
  align-items: flex-start;
`;

export const IconWrapper = styled.div`
  margin-right: 12px;
`;

export const ConflictWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  margin-top: 14px;
  padding: 13px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.grayVariations.light};
`;

export const SubmitButton = styled(Button)`
  & > button {
    background-color: ${({ theme }) => theme.colors.tone.yellow};
    border-radius: 2px;
    box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.043);
    border: none;

    & > span {
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
    }
  }

  & > button:hover {
    background-color: ${({ theme }) => theme.colors.tone.yellow};
  }
`;

export const CancelButton = styled(Button)`
  & > button {
    border: 1px solid ${({ theme }) => theme.colors.grayVariations.light};
    border-radius: 2px;
    box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.043);
  }
`;
